import React from "react";

export function MapsButton({ query }) {
  const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex-shrink-0 text-[#9A8F86] hover:text-[#C17F59] transition-colors"
      title="Ouvrir dans Google Maps"
      data-testid="maps-button"
    >
      <span className="text-sm">🗺️</span>
    </a>
  );
}
